import getReviewRow from "../DataDisplayRow/ReviewRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";

class ReviewTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getReviewRow()
    }
}

let reviewTable: ReviewTable | null = null;

export default function getReviewTable(): ReviewTable {
    if (reviewTable === null)
        reviewTable = new ReviewTable()
    return reviewTable
}